import { ComputeDesc } from '90.quickConnect.Models/models';

const mapComputeDesc = (field: ComputeDesc): ComputeDesc =>
  ({
    formula: field.formula,
  } as ComputeDesc);

export default mapComputeDesc;
